var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.urlRessourceEndPoint)?_c('fx-datagrid-vuetify',{ref:"obj_liste",attrs:{"url-ressource-end-point":_vm.urlRessourceEndPoint + '/suivi-paye'},on:{"actualiser":_vm.actualiser}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }